export const pages = [
  { title: "Upload Images", url: "/upload-images", dataCy: "nav-upload" },
  { title: "Download Images", url: "/download-images", dataCy: "nav-download" },
];